<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><a href="#/Content#cd4ds3" id="nhjgb89">KEY</a></p>
<table style="font-size: small;" width="100%">
<colgroup>
<col width="17%"/>
<col width="83%"/>
</colgroup>
<tbody><tr>
<td valign="top">BW-ST:</td>
<td class="hang" valign="top"><i>Broken Wings</i> by Kahlil Gibran, in <i>A Second Treasury of Kahlil Gibran,</i> trans. by Anthony R. Ferris, Citadel Press, 1962.</td>
</tr>
<tr>
<td valign="top">KG-P:</td>
<td class="hang" valign="top"><i>Kahlil Gibran: A Biography</i> by Michael Naimy, in <i>The Parables of Gibran</i> by Annie Salem Otto, Citadel Press, 1963.</td>
</tr>
<tr>
<td valign="top">P:</td>
<td class="hang" valign="top"><i>The Procession</i> by Kahlil Gibran, trans. by George Kheirallah, Philosophical Library, 1958.</td>
</tr>
<tr>
<td valign="top">MS:</td>
<td class="hang" valign="top"><i>Mirrors of the Soul, Kahlil Gibran,</i> by Joseph Sheban, Philosophical Library, 1965.</td>
</tr>
<tr>
<td valign="top">S:</td>
<td class="hang" valign="top">In conversation and correspondence.</td>
</tr>
<tr>
<td valign="top">SH-P:</td>
<td class="hang" valign="top"><i>Secrets of the Heart</i> by Kahlil Gibran in <i>The Parables of Gibran.</i></td>
</tr>
<tr>
<td valign="top">SH-T:</td>
<td class="hang" valign="top"><i>Secrets of the Heart</i> by Kahlil Gibran in <i>A Treasury of Kahlil Gibran,</i> trans. by Anthony Rizcallah Ferris, edited by Martin L. Wolf, Citadel Press, 1947.</td>
</tr>
<tr>
<td valign="top">SP-P:</td>
<td class="hang" valign="top"><i>Kahlil Gibran: A Self Portrait,</i> trans. by Anthony R. Ferris, in <i>The Parables of Gibran.</i></td>
</tr>
<tr>
<td valign="top">SR-T:</td>
<td class="hang" valign="top"><i>Spirits Rebellious</i> by Kahlil Gibran in <i>A Treasury of Kahlil Gibran.</i></td>
</tr>
<tr>
<td valign="top">T:</td>
<td class="hang" valign="top"><i>A Treasury of Kahlil Gibran.</i></td>
</tr>
<tr>
<td valign="top">TL-T:</td>
<td class="hang" valign="top"><i>Tears and Laughter</i> by Kahlil Gibran in <i>A Treasury of Kahlil Gibran.</i></td>
</tr>
<tr>
<td valign="top">VM-V:</td>
<td class="hang" valign="top"><i>The Voice of the Master</i> by Kahlil Gibran in <i>The Parables of Gibran.</i></td>
</tr>
<tr>
<td valign="top">WM-ST:</td>
<td class="hang" valign="top"><i>The Words of the Master</i> by Kahlil Gibran in <i>A Second Treasury of Kahlil Gibran.</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// key.vue?af72b1b2